import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserRouter, RouterProvider, RouteObject } from 'react-router-dom';
import './index.css'
import Home from './app/Home'
import AgencyProfile from 'app/AgencyProfile';

const routerInfoArray: RouteObject[] = [
  ...['/', '/index', '/index.htm', '/index.html'].map(path => ({
    path,
    element: <Home />
  })),
  {
    path: '/agency/:agencyId',
    element: <AgencyProfile />
  }
]

const routerInfo = createBrowserRouter(routerInfoArray)

ReactDOM.render(
  // <React.StrictMode>
  <RouterProvider router={routerInfo} />,
  // </React.StrictMode>
  document.getElementById('root')
)